import { render, staticRenderFns } from "./menuIcon.vue?vue&type=template&id=4836556c&scoped=true"
import script from "./menuIcon.vue?vue&type=script&lang=js"
export * from "./menuIcon.vue?vue&type=script&lang=js"
import style0 from "./menuIcon.vue?vue&type=style&index=0&id=4836556c&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4836556c",
  null
  
)

export default component.exports